import classNames from "classnames";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { IconSearchLg } from "@pentabd/icons";
import { Input } from "@pentabd/ui";

export const SearchBox = ({
  control,
  placeholder,
  large,
  handleQuery,
}: {
  control: any;
  placeholder?: string;
  large?: boolean;
  handleQuery: (key: string, value: number | string) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Controller
      name="search"
      control={control}
      render={() => (
        <Input
          name="search"
          outline
          placeholder={t(
            placeholder ? placeholder : "EMPLOYEES.TABLE.SEARCH_BOX",
          )}
          prefix={<IconSearchLg fill="info" height="20" width="20" />}
          size="sm"
          className={classNames({
            "search-box-width": large,
          })}
          status="info"
          type="text"
          onChange={(e) => handleQuery("search", e.target.value)}
          controlling
        />
      )}
    />
  );
};
